// Based on http://bl.ocks.org/eric1234/77720eb0da524a049c2b
// Message displayed to user. Depending on browser and if it is a turbolink,
// regular link or user-driven navigation this may or may not display.

// Default state
let unsaved = false;

// Mark the page as having unsaved content
document.addEventListener('change', (event) => {
  const form = event.target.closest('form.unsaved-alert');
  if (form) {
    unsaved = true;
  }
});

// A new page was loaded via Turbo, reset state
document.addEventListener('turbo:load', () => {
  setTimeout(() => {
    unsaved = false;
  }, 250);
});

// The user submitted the form (to save) so no need to ask them
document.addEventListener('submit', (event) => {
  if (event.target.method === 'post') {
    unsaved = false;
  }
});

// Confirm with user if they try to go elsewhere
window.addEventListener('beforeunload', (event) => {
  if (unsaved) {
    // Focus the first visible form input
    // const firstVisibleInput = document.querySelector('form input[type=text]:visible, form textarea:visible, form select:visible');
    // if (firstVisibleInput) {
    //   firstVisibleInput.focus();
    // }

    // Modern browsers require returnValue to be set
    event.preventDefault();
    event.returnValue = 'You have unsaved changes. Are you sure you want to leave this page?'

    return event.returnValue;
  }
});

// If page about to change via Turbo also confirm with user
document.addEventListener('turbo:before-visit', (event) => {
  if (unsaved) {
    // Focus the first visible form input
    // const firstVisibleInput = document.querySelector('form input[type=text]:visible, form textarea:visible, form select:visible');
    // if (firstVisibleInput) {
    //   firstVisibleInput.focus();
    // }

    const msgTurbo = "You have unsaved changes. Are you sure you want to leave this page? Click 'Cancel' to stay. Click 'OK' to discard changes and leave."

    if (!confirm(msgTurbo)) {
      event.preventDefault();
    }
  }
});
